export default "__VITE_ASSET__1fd5aa4c__"